import { useContext, useMemo } from "react";

import { AuthContext } from "../context/authContext";
import {
  hasModuleAccess,
  hasAnyModuleAccess,
  isAdminUser,
} from "../constants/appModules";

export default function useModuleAccess() {
  const { user, allowedModules, modulesReady } = useContext(AuthContext);
  const isAdmin = isAdminUser(user);

  const hasModule = useMemo(
    () => (moduleName) =>
      isAdmin || hasModuleAccess(allowedModules, moduleName),
    [allowedModules, isAdmin],
  );

  const hasAnyModule = useMemo(
    () => (moduleNames) =>
      isAdmin || hasAnyModuleAccess(allowedModules, moduleNames),
    [allowedModules, isAdmin],
  );

  return {
    user,
    allowedModules,
    modulesReady,
    isAdmin,
    hasModule,
    hasAnyModule,
    licenceId: user?.licenceId ?? null,
  };
}
